import axios from 'axios';
import { useNavigate} from 'react-router-dom';


// Add request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('access_token');
      localStorage.removeItem('is_superuser');
      // window.location.href = '/login';
      // const token = localStorage.getItem('access_token');
      // console.log('token', token);
      // if(!token){
        window.location.href = '/login';
        // const navigate = useNavigate();
        // navigate('/login');
      // }
      console.error('Unauthorized access - redirecting to login');

    }
    return Promise.reject(error);
  }
);